import axios from 'axios'
const state = {
	myEvents: {
		results: []
	},
	currentFilter: ''
}

const getters = {

}

const mutations = {
	setMyEvents (state, events) {
		state.myEvents = events
	},
	setMyEventsFilter (state, filter) {
		state.currentFilter = filter
	}
}

const actions = {
	fetchMyEvents (context, index) {
		axios.get('/api/events/favourites/', { params: {page: index} })
			.then(response => {
				const events = { ...response.data, currentPage: index || 1 }
				context.commit('setMyEvents', events)
			})
			.catch(error => {
				console.error(error)
			})
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/myEvents.js